<template>
  <div class="flex flex-col w-full mb-3">
    <label
      v-if="label"
      :for="resolvedId"
      class="fluid-sm leading-tightest mb-2 font-light text-black"
      :class="[{ 'text-br-red': error }, { 'text-gray-500': disabled }]"
    >
      {{ label }}
      <span v-if="required" class="text-br-red">*</span></label
    >
    <div class="relative w-full" :class="higher ? 'h-10' : 'h-9'">
      <input
        :id="resolvedId"
        v-bind="$attrs"
        :type="inputType"
        :disabled="disabled"
        class="text-[16px] md:fluid-sm leading-tightest placeholder:text-[#162022] w-full h-full pl-5 pr-8 outline outline-1 outline-offset-0 outline-lighter-gray hover:outline-blackly focus-visible:focus-ring"
        :class="[
          disabled ? 'text-gray-500' : 'text-black',
          !error ? 'bg-lighter-gray' : 'bg-br-red/20 outline-br-red/20',
        ]"
        :aria-invalid="error ? true : null"
        :aria-describedby="error ? `${resolvedId}-error` : null"
        :value="modelValue"
        :placeholder="placeholder ? placeholder : ''"
        @input="emitValue"
        :autocomplete="autocomplete"
      />
      <div class="absolute top-0 right-0 flex flex-row h-full">
        <div v-if="error" class="h-9 w-9 flex items-center justify-center">
          <WarningIcon class="h-4" />
        </div>
        <div
          v-if="type === 'password'"
          class="h-9 w-9 flex items-center justify-center cursor-pointer"
          @click="togglePasswordVisibility"
        >
          <EyeIcon class="h-3.5" />
        </div>
      </div>
    </div>
    <div class="fluid-xs leading-tightest text-medium py-1">
      <p v-if="helpText">{{ helpText }}</p>
      <p v-if="error" :id="`${resolvedId}-error`" class="text-br-red">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import WarningIcon from '@/components/icons/WarningIcon';
import EyeIcon from '@/components/icons/EyeIcon';
export default defineNuxtComponent({
  name: 'FormTextInput',
  components: {
    WarningIcon,
    EyeIcon,
  },
  inheritAttrs: false,
  setup() {
    const generatedId = useId();
    return { generatedId };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    autocomplete: {
      type: String,
      default: undefined,
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    higher: {
      type: Boolean,
      default: false,
    },
    helpText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    resolvedId() {
      return this.id || this.generatedId;
    },
    inputType() {
      if (this.type !== 'password') {
        return this.type;
      }
      return this.showPassword ? 'text' : 'password';
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    emitValue(e) {
      this.$emit('update:modelValue', e.target.value);
    },
  },
});
</script>
